import React from 'react';
import PropTypes from 'prop-types';

const CloseIcon = ({ className }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="100%"
        height="100%"
        className={className}
        aria-hidden="true"
        focusable="false"
    >
        <line x1="6" y1="6" x2="18" y2="18" stroke="#3C3C3C" strokeWidth="1.2" strokeLinecap="round" />
        <line x1="18" y1="6" x2="6" y2="18" stroke="#3C3C3C" strokeWidth="1.2" strokeLinecap="round" />
    </svg>
);

CloseIcon.propTypes = {
    className: PropTypes.string,
};

CloseIcon.defaultProps = {
    className: '',
};

export default CloseIcon;
